<template>
  <div>
    <v-expansion-panels
      v-if="activeTab === ShowPlansType.ALL_PLANS && !!!activeFilter"
      flat
      accordion
      class="plans-container pb-4"
    >
      <v-expansion-panel
        v-for="(item, index) in plans"
        :key="index"
        :class="{ gradient: item.isVIP }"
      >
        <v-expansion-panel-header class="px-6">
          <div class="d-flex align-center justify-space-between">
            <div class="d-flex align-start mt-3 w-25" style="gap: 20px;">
              <v-img
                :src="item.coinDto.logoUrl"
                style="max-width: 40px;height: 40px"
                class="mb-1"
              />
              <div class="d-flex flex-column align-start justify-center">
                <div
                  class="d-flex align-center justify-center pb-2"
                  style="gap: 3px"
                >
                  <div class="font-Regular-18">
                    {{ item.coinDto.displayName }}
                  </div>
                  <div class="font-Regular-12 gray2--text">
                    ({{ item.coinDto.coinUnit }})
                  </div>
                </div>
                <div
                  class="font-Light-14 gray2--text text-truncate pb-2 custom-des"
                  :class="{ 'gradient-text': item.isVIP }"
                >
                  {{ item.description }}
                </div>
              </div>
            </div>
            <!--            <div class="text-center w-25 d-none d-md-block">-->
            <!--              <div-->
            <!--                class="d-flex align-center mb-2 font-Regular-14 gray2&#45;&#45;text"-->
            <!--                style="gap: 8px"-->
            <!--              >-->
            <!--                <v-icon size="18" clr="var(&#45;&#45;v-gray2-base)">$reward</v-icon>-->
            <!--                <span>{{-->
            <!--                  $t("staking.stakingPlans.plans.details.minMaxAPR")-->
            <!--                }}</span>-->
            <!--              </div>-->
            <!--              <span-->
            <!--                class="font-Regular-14"-->
            <!--                v-if="item.maxActiveApy !== item.minActiveApy"-->
            <!--              >-->
            <!--                {{ item.maxActiveApy }}% - {{ item.minActiveApy }}%</span-->
            <!--              ><span v-else>{{ item.maxActiveApy }}%</span>-->
            <!--            </div>-->
            <!--            <div-->
            <!--              class="d-none d-md-flex flex-column align-center text-center w-25"-->
            <!--            >-->
            <!--              <div-->
            <!--                class="d-flex align-center mb-2 font-Regular-14 gray2&#45;&#45;text"-->
            <!--                style="gap: 8px"-->
            <!--              >-->
            <!--                <v-icon size="18" clr="var(&#45;&#45;v-gray2-base)">$timer</v-icon>-->
            <!--                <span>{{-->
            <!--                  $t("staking.stakingPlans.plans.details.planDateRange")-->
            <!--                }}</span>-->
            <!--              </div>-->
            <!--              <span-->
            <!--                class="font-Regular-14"-->
            <!--                v-if="item.minDuration !== item.maxDuration"-->
            <!--                >{{ item.minDuration }} {{ $t("common.until_2") }}-->
            <!--                {{ item.maxDuration }} {{ $t("common.day") }}</span-->
            <!--              >-->
            <!--              <span v-else> {{ item.maxDuration }} {{ $t("common.day") }}</span>-->
            <!--            </div>-->

            <div class="text-center w-25 d-none d-sm-block">
              <div
                v-if="item.isVIP"
                class="rounded-lg gray11 pa-2"
                style="width: 107px;"
              >
                <v-icon>$vip</v-icon>
                <span class="ms-2 font-Medium-14">{{
                  $t("staking.stakingPlans.plans.details.vipPlan")
                }}</span>
              </div>
            </div>

            <div class="align-center d-none d-md-flex w-25" style="gap: 8px">
              <div
                class="text-center"
                v-for="(apr, index) in item.detailDtoList.slice(0, 4)"
                :key="index"
              >
                <div class="rounded-lg gray11 pa-2" style="width: 130px;">
                  <span class="gray2--text"
                    >{{ apr.duration }} {{ $t("common.day") }}</span
                  >
                  <!--          this is flexible apr-->
                  <template v-if="apr.minApy && apr.maxApy" dir="ltr">
                    <div
                      class="d-flex align-center justify-center mt-2"
                      style="gap: 4px"
                    >
                      <span>% {{ apr.maxApy }}</span>
                      <span class="success--text font-Bold-14"
                        >{{ apr.activeAPY }}%≈</span
                      >
                      <span class="">% {{ apr.minApy }}</span>
                    </div>
                  </template>
                  <!--          this is active apr-->
                  <template v-else>
                    <div class="mt-2 success--text font-Bold-14">
                      % {{ apr.activeAPY }}
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <!--            <div class="flex-1">-->
            <!--              {{ $t("staking.stakingPlans.plans.flexibleConditions") }}-->
            <!--            </div>-->
            <div class="d-xl-none"></div>
            <div class="d-xl-none"></div>
            <div class="d-xl-none"></div>
            <div class="d-none d-md-block"></div>
            <div class="d-none d-md-block"></div>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <PlansDetail
            :itemData="item.detailDtoList"
            :coin-unit="item.coinDto.coinUnit"
            :staking-plan-id="item.stakingPlanId"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <PlansDetail
      v-else-if="activeTab === ShowPlansType.ALL_PLANS && !!activeFilter"
      v-for="(item, index) in plans"
      :key="index"
      :itemData="item.detailDtoList"
      :coin-unit="item.coinDto.coinUnit"
      :staking-plan-id="item.stakingPlanId"
      :logo-url="item.coinDto.logoUrl"
      :single="true"
    />
    <MyPlansCard
      v-if="activeTab === ShowPlansType.MY_PLANS"
      :plans="plans"
      :activeFilter="activeFilter"
    />
  </div>
</template>

<script>
import PlansDetail from "@/components/Staking/MainPage/StakingPlans/PlansDetail.vue";

// Services
import MyPlansCard from "@/components/Staking/MainPage/MyPlans/MyPlansCard.vue";
import { ShowPlansType } from "@/store/types";

export default {
  computed: {
    ShowPlansType() {
      return ShowPlansType;
    }
  },
  components: { MyPlansCard, PlansDetail },
  props: ["activeTab", "activeFilter", "activeShow", "plans"],
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.custom-des {
  width: 100px;
}
.w-25 {
  width: 100%;
}
@media screen and (min-width: 768px) {
  .w-25 {
    width: 150px;
  }
  .custom-des {
    width: 200px;
  }
}
.plans-container {
  margin-top: 60px;
  gap: 24px;
}

.flex-1 {
  flex: 1;
}

.gradient {
  border: 1px solid var(--v-primary-base);
}

.inner-box {
  width: 100%;
  height: 100%;
  border-radius: 7px;
}

.inner-box {
  width: 100%;
  height: 100%;
  border-radius: 7px;
}

.gradient-text {
  background: linear-gradient(to right, #f1ac1c, #2354e7);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  padding-bottom: 2px;
}

.flex-1 {
  flex: 1;
}

.v-expansion-panel {
  background-color: var(--v-gray10-base) !important;
  border-radius: 16px !important;
  width: 100%;
  height: 100%;
  overflow: hidden;
  //max-width: 85% !important;
  //margin-left: auto;

  .v-expansion-panel-header {
    height: 72px !important;
    border: none !important;
  }
}
</style>
